import React, { useState } from 'react';
import { Clock, Menu, X } from 'lucide-react';
import { trackAddToCart } from './MetaPixel';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const handleBuyClick = e => {
    // Track AddToCart event
    trackAddToCart();
  };
  return <header className="w-full" data-id="element-158">
      {/* Top banner for urgency */}
      <div className="bg-indigo-900 text-white py-2 px-4 text-center text-sm flex items-center justify-center" data-id="element-159">
        <Clock size={16} className="mr-2" data-id="element-160" />
        <span data-id="element-161">¡OFERTA DISPONIBLE SOLO POR 24 HORAS! 50% de descuento</span>
      </div>
      {/* Navigation */}
      <nav className="bg-white shadow-sm py-4 px-6 flex justify-between items-center" data-id="element-162">
        <div className="font-bold text-xl text-indigo-900" data-id="element-163">
          30 Días Frecuencia Prohibida
        </div>
        {/* Mobile menu button */}
        <button className="md:hidden text-indigo-900" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-164">
          {isMenuOpen ? <X size={24} data-id="element-165" /> : <Menu size={24} data-id="element-166" />}
        </button>
        {/* Desktop navigation */}
        <div className="hidden md:flex space-x-6" data-id="element-167">
          <a href="#programa" className="text-indigo-700 hover:text-indigo-900" data-id="element-168">
            El Programa
          </a>
          <a href="#testimonios" className="text-indigo-700 hover:text-indigo-900" data-id="element-169">
            Testimonios
          </a>
          <a href="#preguntas" className="text-indigo-700 hover:text-indigo-900" data-id="element-170">
            FAQ
          </a>
          <a href="#inscripcion" className="bg-indigo-600 text-white px-4 py-2 rounded-md hover:bg-indigo-700 transition" onClick={handleBuyClick} data-id="element-171">
            Acceder Ahora
          </a>
        </div>
        {/* Mobile menu */}
        {isMenuOpen && <div className="absolute top-[86px] left-0 right-0 bg-white shadow-md z-10 p-4 md:hidden" data-id="element-172">
            <div className="flex flex-col space-y-3" data-id="element-173">
              <a href="#programa" className="text-indigo-700 hover:text-indigo-900 py-2" data-id="element-174">
                El Programa
              </a>
              <a href="#testimonios" className="text-indigo-700 hover:text-indigo-900 py-2" data-id="element-175">
                Testimonios
              </a>
              <a href="#preguntas" className="text-indigo-700 hover:text-indigo-900 py-2" data-id="element-176">
                FAQ
              </a>
              <a href="#inscripcion" className="bg-indigo-600 text-white px-4 py-2 rounded-md hover:bg-indigo-700 transition text-center" onClick={handleBuyClick} data-id="element-177">
                Acceder Ahora
              </a>
            </div>
          </div>}
      </nav>
    </header>;
}